import type { AddonPriceSectionProps } from '@/open-web/hooks/useAddonPrice/useAddonPrice'
import { useAddonPrice } from '@/open-web/hooks/useAddonPrice/useAddonPrice'
import type { PriceSectionCommonProps } from '@/shared/sections/PriceSection'
import { PriceSection } from '@/shared/sections/PriceSection'

export const AddonPriceSection = ({
  addon,
  showLabel,
  customerType,
  priceItems: propsPriceItems,
  boxProps,
  colors,
  priceItemFontSize = 'm',
  priceStrikeThroughSize = 's',
  priceLabelFontSize = 's',
}: AddonPriceSectionProps & PriceSectionCommonProps) => {
  const { priceItems } = useAddonPrice({
    addon,
    customerType,
    showLabel,
    priceItems: propsPriceItems,
  })

  return (
    <PriceSection
      priceItemFontSize={priceItemFontSize}
      priceStrikeThroughSize={priceStrikeThroughSize}
      colors={colors}
      priceItems={priceItems}
      boxProps={boxProps}
      priceLabelFontSize={priceLabelFontSize}
    />
  )
}
